import { MeasurementUtility } from '@inter-ikea-kompis/utilities';
import { useServiceSettings } from 'contexts/serviceSettings';
import { useTranslations } from 'hooks/useTranslations';
import { useIntl } from 'react-intl';

export const DynamicSizeTitle = ({
  translationKey,
  size
}: {
  translationKey: string;
  size: number;
}) => {
  const { formatMessage } = useIntl();
  const { unit, useMetric } = useTranslations();
  const { translations } = useServiceSettings();

  const height = useMetric
    ? size / 10
    : MeasurementUtility.metricToImperial(translations.kompis, size);

  return `${formatMessage({ id: translationKey })} ${height} ${unit}`;
};
